// Module
var code = `<template> <div class="page-404"> <span class="title">404</span> <p class="sub-title">Page not found!</p> </div> </template> `;
// Exports
module.exports = code;